import React, { FC, PropsWithChildren } from 'react';
import { Tooltip } from '../Tooltip/Tooltip';
import { SystemIcon, SystemIconProps } from '../Icon';
import { TooltipProps } from '../Tooltip';
import styled from 'styled-components';
import InputLabel, { InputLabelProps } from '@material-ui/core/InputLabel';

export type LabelWithIconProps = PropsWithChildren<
  InputLabelProps & {
    dataTest?: string;
    slotProps: {
      tooltipProps: Omit<TooltipProps, 'children'>;
      iconProps?: SystemIconProps;
    };
  }
>;

export const LabelWithIcon: FC<LabelWithIconProps> = ({ children, dataTest, slotProps, ...inputLabelProps }) => (
  <StyledLabelWithIcon data-test={dataTest}>
    <InputLabel {...inputLabelProps}>{children}</InputLabel>
    <StyledTooltip>
      <Tooltip placement="top" {...slotProps.tooltipProps}>
        <SystemIcon name="info" size={18} {...slotProps?.iconProps} />
      </Tooltip>
    </StyledTooltip>
  </StyledLabelWithIcon>
);

const StyledLabelWithIcon = styled.div`
  align-items: center;
  display: inline-flex;
`;

const StyledTooltip = styled.div`
  margin-left: 0.25rem;
  position: relative;
  top: -1px;
`;
